import { Suspense, lazy, useEffect, useState } from 'react';
import '../db/firebaseInit';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import ScrollToTop from '../components/util/ScrollToTop';
import Header from '../components/Header/Header';
import Loader from '../components/util/Loader';
import NavBar from '../components/Home/NavBar';
import { auth } from '../db/auth';

const Home = lazy(() => import('../components/Home/Home'));
const Contact = lazy(() => import('../components/contact/Contact'));
const AboutUs = lazy(() => import('../components/contact/AboutUs'));

//medical
const Doctor = lazy(() => import('../components/medical/Doctor'));
const MedicalPage = lazy(()=>import('../components/medical/MedicalPage'));
const SpecialistPage = lazy(()=>import('../components/medical/Specialist'));

//Emergency
const Police = lazy(() => import('../components/emergency/Police'));
const Ambulance = lazy(() => import('../components/emergency/Ambulance'));
const Fire = lazy(() => import('../components/emergency/FireBrigade'));
const Hospital = lazy(() => import('../components/emergency/Hospital'));
const Wbsedcl = lazy(() => import('../components/emergency/Wbsedcl'));

//Education
const Education = lazy(() => import('../components/education/Education'));

//Transport
const Toto = lazy(() => import('../components/transport/Toto'));
const Rental = lazy(() => import('../components/transport/Rental'));

const ServicePage = lazy(() => import('../components/service/ServicePage'));

//Admin
const Admin = lazy(() => import('../components/admin/AdminPage'));

//Auth
const Login = lazy(() => import('../components/auth/Login'));
const ForgetPassword = lazy(() => import('../components/auth/ForgetPassword'));

//Privacy
const Privacy = lazy(() => import('../components/util/PrivacyPolicy'));

//Feeds
const FeedScreen = lazy(() => import('../components/feed/AdsJobsPage'));

//Contribution
const Contribution = lazy(() => import('../components/contribution/Contribution'));

function App() {
  const [user, setUser] = useState(null);

  useEffect(()=>{
    const unsubscribe=auth.onAuthStateChanged(userAuth=>{
      setUser(userAuth);
    })
    return unsubscribe;
  },[])

  return (
    <div className='text-center' style={{ fontFamily:"'Nunito',sans-serif", background:"#F2F4FA", margin:"0 auto", minHeight:"100vh", position:"relative" }}>
      <BrowserRouter>
          <Header />
          <Suspense fallback={<Loader />}>
            <ScrollToTop />
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/aboutUs' element={<AboutUs />} />

              <Route path='/medical/:type' element={<MedicalPage />} />
              <Route path='/specialist' element={<SpecialistPage />} />
              <Route path='/specialist/:speciality' element={<Doctor />} />

              <Route path='/emergency/police' element={<Police />} />
              <Route path='/emergency/fire' element={<Fire />} />
              <Route path='/emergency/ambulance' element={<Ambulance />} />
              <Route path='/emergency/hospital' element={<Hospital />} />
              <Route path='/emergency/wbsedcl' element={<Wbsedcl />} />

              <Route path='/education/:title' element={<Education />} />

              <Route path='/transport/toto' element={<Toto />} />
              <Route path='/transport/car' element={<Rental />} />

              <Route path='/service/:type' element={<ServicePage />} />

              <Route path='/feeds/:type' element={<FeedScreen />} />
              <Route path='/contribution' element={<Contribution />} />

              <Route path='/admin' element={user?<Admin />:<Login />} />

              <Route path='/login' element={user?<Navigate to="/admin" replace />:<Login />} />
              <Route path='/forgetPassword' element={<ForgetPassword />} />
              <Route path='/privacy' element={<Privacy />} />
              <Route path='*' element={<Navigate to="/" />} />
            </Routes>
          </Suspense>
          <div style={{ marginBottom: "4.6rem" }}></div>
          <NavBar />
        </BrowserRouter>
    </div>
  );
}

export default App;
